import { CostAdjustmentDetailPrintModel } from "./cost-adjustment-print-detail-model";

export class CostAdjustmentPrintModel {
    costAdjustmentId: number = 0;
    companyId: number = 0;
    enterpriseId: number = 0;
    enterpriseLogo: string | null = null;
    enterpriseNit: string = '';
    enterpriseName: string = '';
    inventoryId: number = 0;
    inventoryCode: number = 0;
    inventoryName: string = '';
    branchId: number = 0;
    branchCode: number = 0;
    branchName: string = '';
    address: string = '';
    phone: string = '';
    consecutive: number = 0;
    dateCostAdjustment: Date = new Date();
    provider: string = '';
    remission: string | null = null;
    invoice: string | null = null;
    observation: string | null = null;
    costAdjustmentDetails: CostAdjustmentDetailPrintModel[] = [];
}